import React, { useState, useRef, createContext } from 'react';

export const CheckboxFiltersContext = createContext({
  selectedRows: [],
  setSelectedRows: () => {},
  toggleRow: () => {},
  toggleSelectAll: () => {},
});

export const CheckboxFiltersProvider = ({ children }) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const ignoreNextSelectAll = useRef(false);

  const toggleSelectAll = (checked, allRowIds) => {
    if (ignoreNextSelectAll.current) {
      ignoreNextSelectAll.current = false;
      return;
    }

    setSelectedRows(checked ? allRowIds : []);
  };

  const toggleRow = (id, checked) => {
    setSelectedRows(prev =>
      checked ? (prev.includes(id) ? prev : [...prev, id]) : prev.filter(rowId => rowId !== id),
    );
  };
  return (
    <CheckboxFiltersContext.Provider
      value={{
        selectedRows,
        setSelectedRows,
        toggleRow,
        toggleSelectAll,
      }}>
      {children}
    </CheckboxFiltersContext.Provider>
  );
};
